import { useState } from 'react';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { Navigate, useLocation } from 'react-router';
import { LoadingScreen } from 'src/components/loading-screen';
import Login from 'src/sections/auth/Login';
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

const loginPaths: Record<string, string> = {
  jwt: PATH_AUTH.login,
};

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { authenticated, loading } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!authenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={'/login'} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}

